import { mergeAttributes } from '@tiptap/core';
import Image from '@tiptap/extension-image';

export const CustomImage = Image.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			style: {
				default: null,
				parseHTML: (element) => element.getAttribute('style'),
				renderHTML: (attributes) => {
					if (!attributes.style) return {};
					return { style: attributes.style };
				},
			},
		};
	},
	renderHTML({ HTMLAttributes }) {
		console.log('Image HTMLAttributes', HTMLAttributes);
		return ['img', HTMLAttributes];
	},
});
